export const CLOCKING_RECORDS_DEMO_ORG_ID = 'org-demo-001';

/** シード未ロード時の年月表示フォールバック（実データは 2026-03 付近） */
export const CLOCKING_RECORDS_FALLBACK_YEAR_MONTH = '2026-03';